/**
 * Leitura tolerante das respostas do BFF: o envelope varia entre coleção pura,
 * `{ data }`, `{ data: { items } }` e nomes de campo em inglês ou português.
 */

export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

export function readText(value: unknown): string {
  return typeof value === "string" ? value : "";
}

export function readFirstText(raw: Record<string, unknown>, ...keys: string[]): string {
  for (const key of keys) {
    const text = readText(raw[key]);
    if (text) return text;
  }

  return "";
}

export function readCount(value: unknown): number | null {
  if (typeof value === "number" && Number.isFinite(value)) return value;
  if (typeof value === "string" && value.trim() !== "" && Number.isFinite(Number(value))) {
    return Number(value);
  }

  return null;
}

const ENVELOPE_KEYS = ["data", "items", "content"];

/** `collectionKeys` acrescenta os nomes de coleção próprios do domínio (ex.: `usuarios`). */
export function extractItems(payload: unknown, collectionKeys: string[] = []): unknown[] {
  if (Array.isArray(payload)) return payload;
  if (!isRecord(payload)) return [];

  for (const key of [...ENVELOPE_KEYS, ...collectionKeys]) {
    const nested = payload[key];
    if (nested !== undefined) return extractItems(nested, collectionKeys);
  }

  return [];
}

const TOTAL_KEYS = ["total", "totalRecords", "totalElements", "totalItens"];

export function extractTotal(payload: unknown): number | null {
  if (!isRecord(payload)) return null;

  const meta = isRecord(payload.meta) ? payload.meta : undefined;
  const pagination = isRecord(meta?.pagination)
    ? meta.pagination
    : isRecord(payload.pagination)
      ? payload.pagination
      : undefined;

  for (const source of [pagination, meta, payload]) {
    if (!source) continue;

    for (const key of TOTAL_KEYS) {
      const count = readCount(source[key]);
      if (count !== null) return count;
    }
  }

  return isRecord(payload.data) ? extractTotal(payload.data) : null;
}
